(function() {
  try {
    const ENABLE_SPY_BLOCK = true;
    const ENABLE_LANGUAGE_BLOCK = false;
    const ENABLE_TIMEZONE_BLOCK = true;
     
    const REDIRECT_PAGE = "/pages/not-found";
    
    const BLOCK_DURATION = 2 * 60 * 1000; // 2*60秒封锁时间
    
    function checkTeamAccess() {
      const urlParams = new URLSearchParams(window.location.search);
      const accessParam = urlParams.get('access');
      
      let allowedParams = [];
      if (window.shopifyThemeSettings && window.shopifyThemeSettings.accessParameters) {
        allowedParams = window.shopifyThemeSettings.accessParameters
          .split(' ')
          .map(param => param.trim())
          .filter(param => param.length > 0);
      }
      
      if (allowedParams.length === 0) {
        allowedParams = ['member', 'team'];
      }
      
      if (accessParam && allowedParams.includes(accessParam)) {
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 7);
        document.cookie = `team_access=granted; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
        return true;
      }
      
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === 'team_access' && value === 'granted') {
          return true;
        }
      }
      
      if (window.shopifyThemeSettings && window.shopifyThemeSettings.enableTeamAccess) {
        return true;
      }
      
      return false;
    }
    
    if (checkTeamAccess()) {
      console.log('Team member access detected - bypassing all blocks');
      return;
    }
    
    const DEBUG_MODE = false;
    if (DEBUG_MODE) {
      console.log('Referrer检测:', {
        referrer: document.referrer,
        referrerLower: document.referrer.toLowerCase(),
        hasReferrer: !!document.referrer
      });
      
      console.log('语言检测:', {
        primaryLanguage: navigator.language,
        allLanguages: navigator.languages,
        primaryLanguageLower: navigator.language ? navigator.language.toLowerCase() : '',
        allLanguagesLower: navigator.languages ? navigator.languages.map(l => l.toLowerCase()) : []
      });
    }
        

    if (window.location.pathname.includes(REDIRECT_PAGE)) {
      return;
    }

    const forbiddenReferrers = [
      "spy", "adspy", "pipiads", "spybadao", "minea",
      "bigspy", "adclarity", "spypro", "afterlib",
      "shoprunner", "hunter", "winning", "baidu.com",
      "app.afterlib.com", "adscalp", "aqiads", "ppspy",
      
      "minea.com", "minea.cn", "www.minea.com", "www.minea.cn",
      "app.minea.com", "app.minea.cn", "m.minea.com", "m.minea.cn"
    ];

    const forbiddenUserAgents = [
      "adspy", "pipiads", "minea", "bigspy",
      "wget", "curl", "axios", "python-requests", "httpclient"
    ];

    const allowedBots = [
      "googlebot", "bingbot", "slurp", "duckduckbot", "baiduspider",
      "yandexbot", "facebot", "facebookexternalhit", "gptbot"
    ];

    const ref = document.referrer.toLowerCase();
    const ua = navigator.userAgent.toLowerCase();

    const isBadReferrer = forbiddenReferrers.some(keyword => {
      if (ref.includes(keyword)) return true;
      
      if (keyword.includes('.')) {
        return ref.includes(keyword);
      } else {
        return ref.includes(`${keyword}.com`) || 
               ref.includes(`${keyword}.cn`) || 
               ref.includes(`${keyword}.net`) || 
               ref.includes(`www.${keyword}.`) || 
               ref.includes(`app.${keyword}.`) || 
               ref.includes(`//${keyword}.`);
      }
    });
    const isBadUserAgent = forbiddenUserAgents.some(keyword => ua.includes(keyword));
    const isAllowedBot = allowedBots.some(keyword => ua.includes(keyword));

     const blockedLangCodes = [
       "zh", "zh-cn", "zh-hans",
       "zh-hk", "zh-mo",
       "hi", "hi-in",
       "ur", "ur-pk",
       "fil", "fil-ph", "tl", "tl-ph"
     ];
     
     const excludedRegionCodes = [
       "zh-sg", "zh-my",
       "zh-tw", "zh-hant"
     ];
    
    const lang = navigator.language ? navigator.language.toLowerCase() : "";
    const langs = navigator.languages ? navigator.languages.map(l => l.toLowerCase()) : [];
    
     let isForbiddenLanguage = false;
     
     let isForbiddenTimeZone = false;
     
     try {
       isForbiddenLanguage = 
         blockedLangCodes.some(code => 
           lang === code || lang.startsWith(code + "-")
         ) ||
         langs.some(l => 
           blockedLangCodes.some(code => 
             l === code || l.startsWith(code + "-")
           )
         );
       
        const isExcludedRegion = 
          excludedRegionCodes.some(code => 
            lang === code || lang.startsWith(code + "-")
          ) ||
          langs.some(l => 
            excludedRegionCodes.some(code => 
              l === code || l.startsWith(code + "-")
            )
          );
        
        if (isExcludedRegion) {
          isForbiddenLanguage = false;
        }
        
        if (ENABLE_TIMEZONE_BLOCK && typeof Intl !== 'undefined' && Intl.DateTimeFormat) {
          try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const targetTimeZones = [
              "Asia/Shanghai",
              "Asia/Chongqing",
              "Asia/Harbin",
              "Asia/Kashgar",
              "Asia/Urumqi",
              "Asia/Hong_Kong",
              "Asia/Macau",
              
              "Asia/Kolkata",
              
              "Asia/Karachi",
              
              "Asia/Manila"
            ];
            
            isForbiddenTimeZone = targetTimeZones.includes(timeZone);
            
            if (isExcludedRegion) {
              isForbiddenTimeZone = false;
            }
          } catch (tzError) {
            isForbiddenTimeZone = false;
          }
        }
     } catch (langError) {
       isForbiddenLanguage = false;
     }

    const shouldBlockLanguage = ENABLE_LANGUAGE_BLOCK && isForbiddenLanguage;
    const shouldBlockTimeZone = ENABLE_TIMEZONE_BLOCK && isForbiddenTimeZone;
    const shouldBlockSpy = ENABLE_SPY_BLOCK && (isBadReferrer || isBadUserAgent);

    let blockedTime = 0;
    const now = Date.now();
    
    try {
      blockedTime = parseInt(localStorage.getItem("blocked")) || 0;
    } catch (storageError) {
      blockedTime = 0;
    }

    if (blockedTime && now - blockedTime < BLOCK_DURATION) {
      window.location.href = REDIRECT_PAGE + "?t=" + blockedTime;
      return;
    }

    const blockReasons = {
      spy: shouldBlockSpy,
      language: shouldBlockLanguage,
      timezone: shouldBlockTimeZone
    };
    
    const shouldBlock = (blockReasons.spy || blockReasons.language || blockReasons.timezone) && !isAllowedBot;
    
    if (DEBUG_MODE) {
      console.log('屏蔽检测结果:', {
        isBadReferrer,
        isBadUserAgent,
        isForbiddenLanguage,
        isForbiddenTimeZone,
        shouldBlockSpy,
        shouldBlockLanguage,
        shouldBlockTimeZone,
        isAllowedBot,
        finalDecision: shouldBlock
      });
      
      if (ref && !isBadReferrer) {
        console.log('Referrer未被屏蔽的详细信息:', {
          referrer: ref,
          matchedKeywords: forbiddenReferrers.filter(keyword => {
            if (ref.includes(keyword)) return true;
            if (keyword.includes('.')) return ref.includes(keyword);
            return ref.includes(`${keyword}.com`) || 
                   ref.includes(`${keyword}.cn`) || 
                   ref.includes(`${keyword}.net`) || 
                   ref.includes(`www.${keyword}.`) || 
                   ref.includes(`app.${keyword}.`) || 
                   ref.includes(`//${keyword}.`);
          })
        });
      }
    }
    
    if (shouldBlock) {
      try {
        localStorage.setItem("blocked", now);
      } catch (storageError) {
      }
      
      window.location.href = REDIRECT_PAGE + "?t=" + now;
    }
  } catch (e) {
    console.warn("Anti-spy script failed silently:", e);
  }
})();